export default {
  notifications: state => state.notifications,
  totalFromServer: state => state.totalFromServer,
  watched: state => state.watched,
  unwatched: state => state.unwatched,
  notificationsMenu: state => state.notificationsMenu,
  totalFromServerMenu: state => state.totalFromServerMenu
}
